import { jsx as _jsx } from "react/jsx-runtime";
import fastDeepEqual from "fast-deep-equal/react.js";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { generateDefaultValue, transformInitialRooms } from "./utils.js";
const PanelContext = /*#__PURE__*/ createContext({
    people: [],
    rooms: [],
    onChange: ()=>{}
});
export const PanelAccommodationProvider = (props)=>{
    const { children , rooms: propsRooms , people , onChange  } = props;
    const initialRooms = useMemo(()=>transformInitialRooms(propsRooms || generateDefaultValue(people), people), [
        propsRooms,
        people
    ]);
    const [rooms, setRooms] = useState(initialRooms);
    useEffect(()=>{
        if (!fastDeepEqual(initialRooms, propsRooms)) {
            onChange(initialRooms);
        }
    }, [
        initialRooms,
        propsRooms,
        onChange
    ]);
    useEffect(()=>{
        if (initialRooms) setRooms(initialRooms);
    }, [
        initialRooms
    ]);
    const value = useMemo(()=>({
            rooms,
            people,
            onChange
        }), [
        rooms,
        people,
        onChange
    ]);
    return /*#__PURE__*/ _jsx(PanelContext.Provider, {
        value: value,
        children: children
    });
};
export const usePanelAccommodationContext = ()=>useContext(PanelContext);

//# sourceMappingURL=context.js.map